import React from 'react';
import {headList} from './homeList'
import {thousands} from '../../utils'

const Head = (props) => {
    let {headData} = props
    return (
        <div className="head">
            {
                headList.map((item)=>{
                    return (
                        <div className="container" key={item.name}>
                            <div className="content">
                                <span className={item.icon}></span>
                                <div className="data">
                                    <h5>{item.name}</h5>
                                    <h3>{thousands(headData[item.title])}</h3>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    );
};

export default Head;